import React from 'react';

import HeaderApp from 'components/Header/HeaderApp';
import Bottom from 'components/Bottom';
import ContentSolicitacaoFluxoConfirmarEnvio from './ContentSolicitacaoFluxoConfirmarEnvio';

const SolicitacaoFluxoConfirmarEnvio = () => {
  return (
    <>
      <HeaderApp />
      <ContentSolicitacaoFluxoConfirmarEnvio />
      <Bottom />
    </>
  );
};

export default SolicitacaoFluxoConfirmarEnvio;
